import { FreeMode } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import dayjs from 'dayjs'
import styled from 'styled-components'

import type { components } from '../../../constants/schema'

import { useNavigate } from '../../../hooks/useNavigate'

import { RowBetween, CenterItem } from '../../../components/common'
import { StyledText, Text } from '../../../components/text'

import { Color } from '../../../theme/color'

import 'swiper/css'

interface ArticleBannerProps {
  banners: components['schemas']['HomeItemsDto']['articles']
}

export function ArticleBanner({ banners }: ArticleBannerProps) {
  const navigate = useNavigate()

  return (
    <Swiper modules={[FreeMode]} freeMode={{ enabled: true }} spaceBetween={16} slidesPerView="auto">
      {banners.map(({ id, title, imageUri, category, createdDate }) => {
        const isCategory = !!category

        const navigateUri = () => navigate(`/contents/${id}`)

        return (
          <SwiperSlide key={id}>
            <ArticleItem onClick={navigateUri}>
              <img src={imageUri} alt={title} />
              <ContentBox>
                <Title size={16} weight={500}>
                  {title}
                </Title>
                <CategoryInfo isCategory={isCategory}>
                  {category ? <Category>{category.name}</Category> : null}
                  <Text size={12} color="text_secondary">
                    {dayjs(createdDate).format('YYYY-MM-DD')}
                  </Text>
                </CategoryInfo>
              </ContentBox>
            </ArticleItem>
          </SwiperSlide>
        )
      })}
    </Swiper>
  )
}

const ArticleItem = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 228px;
  border-radius: 8px;
  background-color: ${Color.white};
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.08);
  > img {
    width: 100%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
  }
`

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 16px;
  border-top: 1px solid ${Color.line};
`

const Category = styled(CenterItem)`
  padding: 4px 8px;
  border-radius: 8px;
  background-color: ${Color.gray_2};
  font-size: 14px;
  font-weight: 600;
  color: ${Color.text_secondary};
`

const Title = styled(StyledText)`
  display: -webkit-box;
  overflow: hidden;
  width: 100%;
  height: ${19 * 2}px;
  min-height: 38px;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${2};
`

const CategoryInfo = styled(RowBetween)<{ isCategory: boolean }>`
  ${({ isCategory }) => (isCategory ? '' : 'justify-content: end;')}
  > ${StyledText} {
    line-height: 24px;
  }
`
